var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.883 2.878c.284-1.17 1.95-1.17 2.234 0a1.15 1.15 0 001.715.71c1.029-.626 2.207.551 1.58 1.58a1.148 1.148 0 00.71 1.715c1.17.284 1.17 1.95 0 2.234a1.15 1.15 0 00-.71 1.715c.626 1.029-.551 2.207-1.58 1.58a1.148 1.148 0 00-1.715.71c-.284 1.17-1.95 1.17-2.234 0a1.15 1.15 0 00-1.715-.71c-1.029.626-2.207-.551-1.58-1.58a1.15 1.15 0 00-.71-1.715c-1.17-.284-1.17-1.95 0-2.234a1.15 1.15 0 00.71-1.715c-.626-1.029.551-2.207 1.58-1.58a1.149 1.149 0 001.715-.71z",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 100-4 2 2 0 000 4z",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSettings;